























































import { CatalogListItem } from '@tt4b/ttam-enums';
import { PropType, defineComponent, computed, watch, toRefs, ref } from '@vue/composition-api';
import CatalogItem from './item.vue';
import { useCatalogDisplayList } from '../hooks';
import EmptyContent from '@/components/common/empty-content/index.vue';
import DropdownPanel from '@/components/common/dropdown-panel/index.vue';
import VirtualList from 'vue-virtual-scroll-list';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-product-source-catalog';

export default defineComponent({
  name,
  components: {
    DropdownPanel,
    EmptyContent,
    VirtualList,
  },
  props: {
    list: {
      type: Array as PropType<CatalogListItem[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideGotoCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value, list, disabled } = toRefs(props);
    const popperVisible = ref(false);
    const { keywords, displayList, filterList } = useCatalogDisplayList(list);

    watch(popperVisible, v => {
      if (!v) {
        keywords.value = '';
      } else {
        trackEvent('module_ad_group_catalog_dropdown_click', {
          total_num: list.value.length,
          available_num: list.value.filter(item => !item.disabled).length,
        });
      }
    });

    const currentItem = computed(() =>
      list.value.find(item => {
        const isBCMatch = item.bc_id ? item.bc_id === value.value.bc_id : true;
        return isBCMatch && item.platformId === value.value.platformId;
      }),
    );
    const catalogName = computed(() => currentItem.value?.name ?? '');

    const onFocus = () => {
      if (disabled.value) {
        return;
      }
      popperVisible.value = true;
    };
    const onClick = val => {
      if (val.disabled) {
        return;
      }
      popperVisible.value = false;
      emit('change', val);
      emit('input', val);
    };
    const onClose = () => {
      popperVisible.value = false;
    };

    const handleCreateCatalog = () => {
      trackEvent('module_ad_group_create_catalog_click');
      emit('create-catalog');
      onClose();
    };
    const handleCreateProduct = () => {
      emit('create-product');
    };
    return {
      name,
      CatalogItem,
      keywords,
      displayList,
      filterList,
      popperVisible,
      catalogName,
      currentItem,
      onFocus,
      onClick,
      onClose,
      handleCreateCatalog,
      handleCreateProduct,
    };
  },
});
